import {Component, Input, OnInit} from '@angular/core';
import {TableColumn} from '@app/shared/components/ace-table/ace-table.component';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {CSVPivotData} from "@app/layout/charts/mini-chart/export-data-builder";

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  standalone: false
})
export class DataTableComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  headers: string[];

  @Input()
  keys: string[];

  @Input()
  data: {[key: string]: string}[];

  @Input()
  dataTimestampBounds: {start: number, end: number};

  @Input()
  csvExportFn: (csvPivotData: CSVPivotData) => void;

  columns: TableColumn[];
  rows: {[key: string]: string}[];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.columns = this.keys.map((key, index) => ({name: this.headers[index], prop: key, flexGrow: 1}));
  }

  exportCSV(): void {
    this.csvExportFn({
      bounds: this.dataTimestampBounds,
      data: this.data,
      headers: this.headers,
      keys: this.keys
    });
  }
}
